
import React from "react";

export function StatusBadge({ children, tone = "blue" }) {
    console.log("Function called: StatusBadge");
    const colors = {
        blue: "bg-blue-50 text-blue-700 ring-blue-100",
        green: "bg-emerald-50 text-emerald-700 ring-emerald-100",
        amber: "bg-amber-50 text-amber-700 ring-amber-100",
        slate: "bg-slate-100 text-slate-700 ring-slate-200",
        rose: "bg-rose-50 text-rose-700 ring-rose-100",
    };

    return (
        <span className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-bold ring-1 ${colors[tone]}`}>
            {children}
        </span>
    );
}

export function MetricCard({ metric }) {
    console.log("Function called: MetricCard");
    return (
        <div className="rounded-2xl border border-blue-100 bg-white p-5 shadow-[0_16px_45px_rgba(14,63,182,0.07)]">
            <div className="flex items-start justify-between gap-4">
                <div>
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-slate-500">{metric.label}</p>
                    <p className="mt-3 text-3xl font-extrabold text-[#191E49]">{metric.value}</p>
                    <p className="mt-2 text-sm font-semibold text-blue-600">{metric.note}</p>
                </div>
                <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-blue-50 text-blue-700">
                    <i className={`fa-solid ${metric.icon}`} aria-hidden="true" />
                </span>
            </div>
        </div>
    );
}

export function Panel({ title, eyebrow, children, action }) {
    console.log("Function called: Panel");
    return (
        <section className="rounded-2xl border border-blue-100 bg-white shadow-[0_16px_45px_rgba(14,63,182,0.07)]">
            <div className="flex flex-col gap-4 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:justify-between">
                <div>
                    {eyebrow && <p className="text-xs font-bold uppercase tracking-[0.18em] text-blue-700">{eyebrow}</p>}
                    <h2 className="mt-1 text-xl font-extrabold text-[#191E49]">{title}</h2>
                </div>
                {action}
            </div>
            <div className="p-5">{children}</div>
        </section>
    );
}

export function EmptyState({ title, message, action }) {
    console.log("Function called: EmptyState");
    return (
        <div className="rounded-xl border border-dashed border-blue-200 bg-blue-50/60 p-6 text-center">
            <p className="text-sm font-extrabold text-[#191E49]">{title}</p>
            <p className="mx-auto mt-2 max-w-md text-sm font-semibold leading-6 text-slate-600">{message}</p>
            {action && <div className="mt-4">{action}</div>}
        </div>
    );
}